import { useState } from "react";
import type { Item } from "@/interfaces/item";
import ticketIcon from "@/assets/icons/ticket.svg";
import Modal from "@/components/ui/Modal";
import Button from "@/components/ui/Button";
import { Field, Textarea } from "@/components/ui/Field";

export default function ConfirmPurchaseModal({
  open,
  item,
  quantity,
  totalCost,
  willGoIntoDebt,
  onCancel,
  onConfirm,
}: {
  open: boolean;
  item: Item;
  quantity: number;
  totalCost: number;
  willGoIntoDebt?: boolean;
  onCancel: () => void;
  onConfirm: (note?: string) => void;
}) {
  const [note, setNote] = useState("");

  return (
    <Modal
      open={open}
      title="confirm-purchase"
      onClose={onCancel}
      footer={
        <>
          <Button variant="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button onClick={() => onConfirm(note)}>Confirm</Button>
        </>
      }
    >
      <p className="text-subheading text-ink flex flex-wrap items-center gap-1.5">
        Buy{" "}
        <span className="font-bold">
          {quantity}x {item.name}
        </span>{" "}
        for
        <img src={ticketIcon} alt="Tickets" className="inline h-5 w-5" />
        <span className="font-bold">{totalCost}</span>?
      </p>

      {willGoIntoDebt && (
        <p className="border-sunset-orange bg-sunset-orange/10 text-caption text-sunset-orange mt-3 border-2 px-3 py-2 font-bold">
          ⚠ This purchase will put you into negative tickets! You'll need to
          complete hours after the event to pay it off.
        </p>
      )}

      <div className="mt-5">
        <Field label="Note (optional)">
          <Textarea
            value={note}
            rows={3}
            onChange={(e) => setNote(e.target.value)}
          />
        </Field>
      </div>
    </Modal>
  );
}
